document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wFormContainer form').forEach(function (form) {
        const allHiddenFields = form.querySelectorAll('input[type="hidden"]');
        const customHiddenFields = Array.from(allHiddenFields).filter((field) => {
            // Custom hidden fields are suffixed with an incremental number
            return !isNaN(field.id.replace('tfa_', ''));
        })
        if (customHiddenFields.length > 0) {
            customHiddenFields[0].value = window.location.href;
        }
    });
});

